import React, { PureComponent } from 'react';
import { reset } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import FirstLogInForm from './components/FirstLogInForm';
import { firstLogin } from '../../redux/actions/loginActions';
import { createWarningMessage, createSuccessMessage } from '../../helpers/notification';

class FirstLogInContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      email: null,
    };
  }

  componentDidMount() {
    // Extract token and email from URL parameters
    const { location } = this.props;
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    const email = urlParams.get('email');

    if (token && email) {
      this.setState({ token, email });
      // Store the token and email in localStorage for the form to use
      const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
      localStorage.setItem('currentUser', JSON.stringify({
        ...currentUser,
        email,
        resetToken: token,
        temporalPassword: true,
      }));
    }
  }

  handleSubmit = (values) => {
    const { firstLogin: submit, history, resetForm } = this.props;
    const { token, email } = this.state;

    // Include token and email in the form values
    const formData = {
      ...values,
      token: token || values.token,
      email: email || values.email,
    };

    resetForm('LogInForm');
    return submit(formData,
      {
        onSuccess: () => {
          createSuccessMessage('Nueva contraseña establecidad con éxito');
          history.push('/dashboard_default');
        },
        onError: () => {
          createWarningMessage('Usuario y/o contraseña incorrecto');
        },
      });
  }

  render() {
    const { token, email } = this.state;
    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
    const isResetMode = (token && email) || (currentUser.resetToken && currentUser.temporalPassword);

    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <h3 className="account__title">Establecer nueva contrase&ntilde;a</h3>
            </div>
            <FirstLogInForm
              onSubmit={this.handleSubmit}
              isResetMode={isResetMode}
              email={email || currentUser.email}
              initialValues={{
                email: email || currentUser.email,
              }}
            />
            <div className="account__or d-none">
              <p>Or Easily Using</p>
            </div>
            <div className="account__social d-none">
              <Link
                className="account__social-btn account__social-btn--facebook"
                to="/pages/one"
              ><FacebookIcon />
              </Link>
              <Link
                className="account__social-btn account__social-btn--google"
                to="/pages/one"
              ><GooglePlusIcon />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FirstLogInContainer.propTypes = {
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  firstLogin: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
  firstLogin,
  resetForm: reset,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FirstLogInContainer);
